import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import BrandLogo from '@/assets/icons/BrandLogo.svg?react';
import CustomerAreaLogoNavigation from '@/assets/icons/CustomerAreaLogoNavigation.svg?react';
import SidebarDemoBadge from '@/components/SidebarDemoBadge/SidebarDemoBadge';
import { ROUTE } from '@/constants/route';
import joinClassNames from '@/utils/functions/joinClassNames/joinClassNames';

import SidebarFooter from './SidebarComponents/SidebarFooter';
import SidebarNav from './SidebarComponents/SidebarNav';
import styles from './styles.module.css';
import useSidebarMenu from './useSidebarMenu';

/**
 * Permanently visible navigation, mounted above the tablet breakpoint.
 * It is not dismissible, hence a `<nav>` landmark rather than a `<dialog>`.
 */
const SidebarDesktop = () => {
  const { t } = useTranslation();
  const { isDemo, hasAdvisorView } = useSidebarMenu();

  return (
    <nav
      aria-label={t('navigation.mainMenuLabel')}
      className={joinClassNames(
        styles.sidebar,
        styles.sidebarDesktop,
        hasAdvisorView && styles.sidebarWithBanner,
        isDemo && styles.sidebarWithDemoBanner
      )}
    >
      <div className={styles.sidebarTop}>
        <div className={styles.sidebarHeader}>
          <NavLink to={ROUTE.DASHBOARD}>
            <BrandLogo width={222} height={28} aria-label="logo meilleurtaux" />
          </NavLink>
          <NavLink to={ROUTE.DASHBOARD}>
            <CustomerAreaLogoNavigation width={222} height={33} aria-label="logo espace client" />
          </NavLink>
          {isDemo && <SidebarDemoBadge />}
        </div>

        <SidebarNav />
      </div>

      <SidebarFooter userMenuPlacement="right" />
    </nav>
  );
};

export default SidebarDesktop;
